import { render, staticRenderFns } from "./WireTransferConfiguration.vue?vue&type=template&id=3663ed54&scoped=true"
import script from "./WireTransferConfiguration.vue?vue&type=script&lang=js"
export * from "./WireTransferConfiguration.vue?vue&type=script&lang=js"
import style0 from "./WireTransferConfiguration.vue?vue&type=style&index=0&id=3663ed54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3663ed54",
  null
  
)

export default component.exports